import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface ConfirmDialogData {
  message: string;
  messageId: string;
  /**
   * "alert" renders a single OK button (`data-testid="alert-ok"`), as an
   * in-page replacement for `window.alert()`. Defaults to "confirm".
   */
  kind?: "confirm" | "alert";
  /** Defaults to a translated "OK" (template i18n). */
  okLabel?: string;
  /** Defaults to a translated "Cancel" (template i18n). */
  cancelLabel?: string;
}

/**
 * In-page replacement for `window.confirm()` and `window.alert()`. Opened through `ConfirmService`;
 * closes with `true` on OK and `false` on Cancel (Escape / backdrop close with
 * `undefined`, which the service maps to `false`).
 */
@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) readonly data: ConfirmDialogData) {}
}
